<div class="purchase-container" [class.step-payment]="viewStep === 'payment'" [testId]="'robot-purchase-container'">
  <nz-spin [nzSpinning]="loading || submitting" [testId]="'robot-purchase-spin'">
    <ng-container *ngIf="viewStep === 'packages'; else paymentStepTpl">
      <div class="purchase-layout">
        <aside class="purchase-balance">
          <div class="balance-head">
            <h4 class="balance-title">{{ 'robot-service.purchase.balance.title' | i18n }}</h4>
            <div class="balance-rule-inline">💡 {{ 'robot-service.purchase.balance.rule.summary' | i18n }}</div>
          </div>
          <div class="balance-card-list">
            <div class="balance-card" *ngFor="let card of balanceCards" [class]="getBalanceCardClass(card.type)">
              <div class="balance-name">
                <i nz-icon nzType="star" nzTheme="outline"></i>
                {{ getBalanceNameKey(card.type) | i18n }}
              </div>
              <div class="balance-value">{{ formatPoints(card.points) }}</div>
              <div class="balance-desc">
                {{ 'robot-service.purchase.balance.deduct' | i18n }} ¥{{ getDeductAmount(card.points, card.deductRate) }}
              </div>
            </div>
          </div>
          <div class="balance-rule">
            <div class="rule-title">💡 {{ 'robot-service.purchase.balance.rule.title' | i18n }}</div>
            <div class="rule-line">• {{ 'robot-service.purchase.balance.rule.line1' | i18n }}</div>
            <div class="rule-line">• {{ 'robot-service.purchase.balance.rule.line2' | i18n }}</div>
            <div class="rule-line">{{ 'robot-service.purchase.balance.rule.line3' | i18n }}</div>
          </div>
        </aside>

        <div class="purchase-main-column">
          <div class="purchase-main-head">
            <div
              class="purchase-name-card"
              [class.purchase-name-card-error]="shouldShowRobotNameError()"
              [testId]="'robot-purchase-name-card'"
            >
              <div class="purchase-name-head">
                <div class="purchase-name-title-row">
                  <div class="purchase-name-title">
                    {{ 'robot-service.purchase.name.label' | i18n }}
                    <span class="purchase-name-required-mark">*</span>
                    <span class="purchase-name-required-badge">{{ 'robot-service.purchase.name.required-badge' | i18n }}</span>
                  </div>
                  <div class="purchase-name-type-tag">{{ getIdentityTypeLabel() }}</div>
                </div>
              </div>
              <div class="purchase-name-tip">{{ 'robot-service.purchase.name.tip' | i18n }}</div>
              <input
                class="purchase-name-input"
                [class.purchase-name-input-error]="shouldShowRobotNameError()"
                type="text"
                maxlength="50"
                [ngModel]="robotName"
                (ngModelChange)="robotName = $event"
                (blur)="markRobotNameTouched()"
                [placeholder]="'robot-service.purchase.name.placeholder' | i18n"
                [testId]="'robot-purchase-name-input'"
              />
              <div *ngIf="shouldShowRobotNameError()" class="purchase-name-error" [testId]="'robot-purchase-name-error'">
                {{ 'robot-service.purchase.name-required' | i18n }}
              </div>
            </div>
          </div>

          <div class="purchase-main">
            <div class="package-list" [testId]="'robot-purchase-list'">
              <div
                class="package-item"
                *ngFor="let item of packages; let i = index"
                (click)="selectPackage(item)"
                [class.selected]="isSelected(item)"
                [class.package-item-trial]="isTrialPackage(item)"
                [testId]="'robot-purchase-item-' + i"
              >
                <div class="package-left">
                  <div class="package-name">
                    <span>{{ getPackageTitle(item) }}</span>
                    <nz-tag *ngIf="isTrialPackage(item)" class="trial-tag">
                      {{ 'robot-service.purchase.trial.new-user' | i18n }}
                    </nz-tag>
                  </div>
                  <ng-container *ngIf="!isTrialPackage(item); else trialDescTpl">
                    <div class="package-desc">{{ getPackageDesc(item) }}</div>
                  </ng-container>
                  <ng-template #trialDescTpl>
                    <div class="package-desc-list">
                      <div class="package-desc" *ngFor="let line of getTrialDescList(item)">• {{ line }}</div>
                    </div>
                  </ng-template>
                </div>
                <div class="package-right">
                  <span *ngIf="isTrialPackage(item)" class="trial-free-badge"
                    >🎉 {{ 'robot-service.purchase.trial.limited-free' | i18n }}</span
                  >
                  <div class="package-price-stack">
                    <div class="package-price">{{ getPriceText(item) }}</div>
                    <div class="package-original-price" *ngIf="shouldShowOriginalPrice(item)">{{ getOriginalPriceText(item) }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="purchase-footer" [testId]="'robot-purchase-footer'">
              <div class="purchase-tips">
                <div class="tip-line">{{ 'robot-service.purchase.tip.line1' | i18n }}</div>
                <div class="tip-line">{{ 'robot-service.purchase.tip.line2' | i18n }}</div>
                <div class="tip-line">{{ 'robot-service.purchase.tip.line4' | i18n }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #paymentStepTpl>
      <div class="payment-step">
        <button
          *ngIf="canBackToPackages()"
          nz-button
          nzType="link"
          class="back-link"
          (click)="backToPackages()"
          testId="robot-service-purchase-back-packages-button"
          >{{ 'robot-service.purchase.back-select' | i18n }}</button
        >

        <div class="selected-package-card">
          <div class="selected-package-left">
            <div class="selected-package-name-row">
              <div class="selected-package-name">{{ getPackageTitle(getSelectedPackage()) }}</div>
              <div class="selected-package-type-tag">{{ getIdentityTypeLabel() }}</div>
            </div>
            <div class="selected-package-desc">{{ getPackageDesc(getSelectedPackage()) }}</div>
            <div class="selected-package-meta">
              <span class="selected-package-meta-label">{{ 'robot-service.purchase.name.label' | i18n }}:</span>
              <span class="selected-package-meta-value">{{ robotName || ('robot-service.purchase.name.empty' | i18n) }}</span>
            </div>
          </div>
          <div class="selected-package-price-stack">
            <div class="selected-package-price">{{ getPriceText(getSelectedPackage()) }}</div>
            <div class="selected-package-original-price" *ngIf="shouldShowOriginalPrice(getSelectedPackage())">
              {{ getOriginalPriceText(getSelectedPackage()) }}
            </div>
          </div>
        </div>

        <div class="deduct-card" *ngFor="let card of balanceCards">
          <div class="deduct-head">
            <div class="deduct-title-wrap">
              <span class="deduct-icon deduct-icon-uupon">
                <i nz-icon nzType="star" nzTheme="outline"></i>
              </span>
              <div class="deduct-title">{{ getBalanceNameKey(card.type) | i18n }}{{ 'robot-service.purchase.deduct.title' | i18n }}</div>
            </div>
            <a
              class="deduct-all"
              [class.deduct-all-disabled]="isDeductInputDisabled(card.type)"
              (click)="deductAll(card.type)"
              [testId]="'robot-service-purchase-deduct-all-' + card.type"
              >{{ 'robot-service.purchase.deduct.all' | i18n }}</a
            >
          </div>
          <div class="deduct-meta">
            {{ 'robot-service.purchase.deduct.balance' | i18n }} {{ formatPoints(card.points) }}
            {{ 'robot-service.purchase.deduct.rate' | i18n }} {{ card.deductRate }}{{ 'robot-service.purchase.deduct.rate-unit' | i18n }}
          </div>
          <div class="deduct-input-row">
            <div class="deduct-input-shell">
              <input
                class="deduct-input"
                type="text"
                inputmode="numeric"
                pattern="[0-9]*"
                [disabled]="isDeductInputDisabled(card.type)"
                [ngModel]="deductionInputs[card.type]"
                (beforeinput)="blockNonIntegerInput($event)"
                (input)="onDeductInput(card.type, $event)"
                [placeholder]="'robot-service.purchase.deduct.placeholder' | i18n"
                [testId]="'robot-service-purchase-deduct-input-' + card.type"
              />
              <div class="deduct-amount">-¥{{ getDeductDisplay(card.type) }}</div>
            </div>
          </div>
        </div>

        <div class="cost-summary">
          <div class="summary-title">{{ 'robot-service.purchase.summary.title' | i18n }}</div>
          <div class="summary-line">
            <span>{{ 'robot-service.purchase.summary.price' | i18n }}</span>
            <span>¥{{ getSelectedPackagePrice() }}</span>
          </div>
          <div class="summary-subline">
            <span
              >{{ 'robot-service.purchase.balance.uupon' | i18n }}{{ 'robot-service.purchase.deduct.title' | i18n }}（{{
                getDeductPoints('uupon')
              }}{{ 'robot-service.purchase.summary.points' | i18n }}）</span
            >
            <span>-¥{{ getDeductDisplay('uupon') }}</span>
          </div>
          <div class="summary-payable">
            <span>{{ 'robot-service.purchase.summary.payable' | i18n }}</span>
            <span>¥{{ getPayableDisplay() }}</span>
          </div>
        </div>

        <button
          nz-button
          nzType="primary"
          class="confirm-pay-btn"
          [nzLoading]="submitting"
          [disabled]="!hasValidRobotName()"
          (click)="confirmPay()"
          testId="robot-service-purchase-confirm-pay-button"
        >
          {{ 'robot-service.purchase.confirm-pay' | i18n }}
        </button>
        <div class="confirm-pay-tip">⚠ {{ 'robot-service.purchase.confirm-pay.tip' | i18n }}</div>
      </div>
    </ng-template>
  </nz-spin>
</div>
